import axios from "axios";
import localforage from "localforage";

let baseUrl = import.meta.env.VITE_APP_BASE_URL || "";

const axiosApiInstance = axios.create({ baseURL: baseUrl });

axiosApiInstance.interceptors.request.use(
  async (config) => {
    try {
      const currentToken = await localforage.getItem("token");
      if (currentToken && currentToken !== "") {
        config.headers.set("Authorization", `Bearer ${currentToken}`);
      }
      return config;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  },
  (err) => {
    console.log(err);
    return Promise.reject(err);
  }
);

export default axiosApiInstance;
